module.exports = __webpack_public_path__ + "assets/img/41@3x.fa2c98b0.png";